import { BASE_RADIUS, surfacePoint, Vec3 } from './kilimanjaroGeometry';
import { KILIMANJARO_ROUTES, KiliCamp, KiliRoute, SUMMIT_ELEVATION } from '../data/kilimanjaroRoutes';

export interface CampPoint {
  route: KiliRoute;
  camp: KiliCamp;
  point: Vec3;
  t: number;
}

export interface RoutePath {
  route: KiliRoute;
  /** Dense points tracing the trail along the mountain surface, base to summit. */
  linePoints: Vec3[];
  /** One entry per named camp, in order. */
  campPoints: CampPoint[];
}

const TRAIL_EXTENT = BASE_RADIUS * 1.05;
const SUBSTEPS_BETWEEN_CAMPS = 5;

function campT(route: KiliRoute, camp: KiliCamp): number {
  const base = route.camps[0].elevation;
  const span = SUMMIT_ELEVATION - base || 1;
  return Math.min(1, Math.max(0, (camp.elevation - base) / span));
}

function pointForT(route: KiliRoute, t: number, lift = 0.012): Vec3 {
  const r = TRAIL_EXTENT * (1 - t);
  const angle = route.angleStart + t * route.angleSpan;
  return surfacePoint(r, angle, lift);
}

export function buildRoutePath(route: KiliRoute): RoutePath {
  const campPoints: CampPoint[] = route.camps.map((camp) => {
    const t = campT(route, camp);
    return { route, camp, point: pointForT(route, t, 0.018), t };
  });

  const linePoints: Vec3[] = [];
  for (let i = 0; i < campPoints.length - 1; i++) {
    const a = campPoints[i];
    const b = campPoints[i + 1];
    for (let s = 0; s <= SUBSTEPS_BETWEEN_CAMPS; s++) {
      const t = a.t + ((b.t - a.t) * s) / SUBSTEPS_BETWEEN_CAMPS;
      linePoints.push(pointForT(route, t));
    }
  }

  return { route, linePoints, campPoints };
}

export const ALL_ROUTE_PATHS: RoutePath[] = KILIMANJARO_ROUTES.map(buildRoutePath);
